import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import TestimonialScreen, { wrapTextForRTL } from "./TestimonialScreen";
import NPSScreen from "./NPSScreen";
import ThankYouScreen from "./ThankYouScreen";
import RateFinishSlide from "./RateFinishSlide";
const RateFinish010Feedback = ({
  classes,
  onCancelDialog,
  message,
  handleSubmitNPS,
  handleSubmitNPSFeedback
}) => {
  var _message$custClientRe, _message$custClientRe2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RateFinishSlide, {
    key: 2
  }, /*#__PURE__*/React.createElement(NPSScreen, {
    message: message,
    onSubmitScore: handleSubmitNPS
  })), /*#__PURE__*/React.createElement(RateFinishSlide, {
    key: 3
  }, /*#__PURE__*/React.createElement(TestimonialScreen, {
    headingTitle: wrapTextForRTL("Why did you give us this score?"),
    testimonial: (_message$custClientRe = (_message$custClientRe2 = message.custClientReview) === null || _message$custClientRe2 === void 0 ? void 0 : _message$custClientRe2.feedback) !== null && _message$custClientRe !== void 0 ? _message$custClientRe : "",
    onSubmitTestimonial: handleSubmitNPSFeedback,
    containerClass: classes.container,
    onCancelDialog: onCancelDialog,
    getButtonLabel: () => "Send",
    isMandatory: true,
    id: "testimonialTextareaWithScoreHeading"
  })), /*#__PURE__*/React.createElement(RateFinishSlide, {
    key: 4,
    height: 140
  }, /*#__PURE__*/React.createElement(ThankYouScreen, {
    onCancelDialog: () => onCancelDialog(true)
  })));
};
export default RateFinish010Feedback;
RateFinish010Feedback.propTypes = {
  classes: PropTypes.object.isRequired,
  onCancelDialog: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
  handleSubmitNPS: PropTypes.func.isRequired,
  handleSubmitNPSFeedback: PropTypes.func.isRequired
};